// extracted by mini-css-extract-plugin
module.exports = {"Dimension":"Dimension_Dimension__2d2W5","LastChild":"Dimension_LastChild__1lbBS"};